import apiUrl from "./config/config";
import axios from "axios";

class productFamilyApi {

  static async getProductFamilies(params)
  {

    try
    {

      const response = await axios(apiUrl + "productfamily", {params});

      return response.data;

      // while(true){

      //   const response = await axios(apiUrl + "productFamily", {params});

      // }

    } catch (err)
    {

      throw new Error();

    }

  }

  static async getProductFamily(id = "")
  {

    try
    {

      const response = await axios(apiUrl + "productfamily/" + id);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}







export default productFamilyApi;
